import { render, staticRenderFns } from "./ImprintContactBlock.vue?vue&type=template&id=2a8a42cc"
import script from "./imprintContactBlock.ts?vue&type=script&lang=js&external"
export * from "./imprintContactBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports